/**
 * Opens uploaded cart artwork without exposing a Drip upload URL as an anchor.
 * Drip's legacy cart enhancer rewrites matching anchors and removes their image.
 */
(function () {
  'use strict';

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest && event.target.closest('[data-design-preview-url]');
    if (!trigger) return;

    event.preventDefault();

    try {
      const previewUrl = new URL(trigger.dataset.designPreviewUrl);
      if (previewUrl.protocol !== 'http:' && previewUrl.protocol !== 'https:') return;

      window.open(previewUrl.href, '_blank', 'noopener,noreferrer');
    } catch (error) {
      // Invalid line-item URLs remain inert.
    }
  });
})();
